// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 296) return "static/chunks/ea88be26-3812c7c8a79a1501.js";
	if (chunkId === 9464) return "static/chunks/9464-f39cdbd72cfca48e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"2b09396cfe187c5b","9651":"3ebafe9c3558c628"}[chunkId] + ".js";
};